// Корневой компонент: провайдеры + маршрутизация.
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/hooks/useAuth';
import { ToastProvider } from '@/components/ui/Toast';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { LoginPage } from '@/pages/auth/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { ContractsListPage } from '@/pages/contracts/ContractsListPage';
import { ContractDetailPage } from '@/pages/contracts/ContractDetailPage';
import { ObjectsListPage } from '@/pages/ObjectsPage';
import { ObjectDetailPage } from '@/pages/ObjectDetailPage';
import { EstimatesPage } from '@/pages/EstimatesPage';
import { ProjectsPage } from '@/pages/ProjectsPage';
import { LibraryPage } from '@/pages/LibraryPage';
import { AdminPage } from '@/pages/admin/AdminPage';
import { ChatPage } from '@/pages/chat/ChatPage';
import { MailPage } from '@/pages/mail/MailPage';
import { ProjectDetailPage } from '@/pages/ProjectDetailPage';
import { ActsPage } from '@/pages/ActsPage';
import { EstimateEditorPage } from '@/pages/EstimateEditorPage';
import { NormativePage } from '@/pages/NormativePage';
import { CalendarPage } from '@/pages/CalendarPage';
import { TasksPage } from '@/pages/TasksPage';
import { IntegrationsPage } from '@/pages/IntegrationsPage';
import { PlatformAdminPage } from '@/pages/PlatformAdminPage';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 } },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
              <Route path="/contracts" element={<ProtectedRoute><ContractsListPage /></ProtectedRoute>} />
              <Route path="/contracts/:id" element={<ProtectedRoute><ContractDetailPage /></ProtectedRoute>} />
              <Route path="/objects" element={<ProtectedRoute><ObjectsListPage /></ProtectedRoute>} />
              <Route path="/objects/:id" element={<ProtectedRoute><ObjectDetailPage /></ProtectedRoute>} />
              <Route path="/estimates" element={<ProtectedRoute><EstimatesPage /></ProtectedRoute>} />
              <Route path="/projects" element={<ProtectedRoute><ProjectsPage /></ProtectedRoute>} />
              <Route path="/library" element={<ProtectedRoute><LibraryPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
              <Route path="/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
              <Route path="/mail" element={<ProtectedRoute><MailPage /></ProtectedRoute>} />
              <Route path="/projects/:id" element={<ProtectedRoute><ProjectDetailPage /></ProtectedRoute>} />
              <Route path="/acts" element={<ProtectedRoute><ActsPage /></ProtectedRoute>} />
              <Route path="/estimates/:id" element={<ProtectedRoute><EstimateEditorPage /></ProtectedRoute>} />
              <Route path="/normative" element={<ProtectedRoute><NormativePage /></ProtectedRoute>} />
              <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
              <Route path="/tasks" element={<ProtectedRoute><TasksPage /></ProtectedRoute>} />
              <Route path="/integrations" element={<ProtectedRoute><IntegrationsPage /></ProtectedRoute>} />
              <Route path="/platform" element={<ProtectedRoute><PlatformAdminPage /></ProtectedRoute>} />
            </Routes>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
